/* eslint-disable @typescript-eslint/no-unused-vars */
import { call, put, takeLatest } from "redux-saga/effects";
import { ApiResponse, RemovePayload } from "models";
import { PayloadAction } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { packageActions } from "./packageSlice";
import packageApi from "api/packagesApi";
import { PackageAddForm, PackageUpdateForm } from "models/package";

function* getModuleList(action: PayloadAction<any>) {
  try {
    const response: ApiResponse = yield call(packageApi.getModuleList);
    const data: ApiResponse = response.data;
    if (data.success) {
      yield put(packageActions.getModuleListSuccess(data));
    }
  } catch (error: any) {
    const errorData = error?.response?.data;
    yield put(packageActions.getModuleListFailed(errorData));
  }
}

function* getPackage(action: PayloadAction<any>) {
  try {
    const response: ApiResponse = yield call(
      packageApi.getPackageList,
      action.payload
    );
    const data: ApiResponse = response.data;
    if (data.success) {
      yield put(packageActions.getPackagesSuccess(data));
    }
  } catch (error: any) {
    const errorData = error?.response?.data;
    yield put(packageActions.getPackagesFailed(errorData));
  }
}

function* addPackage(action: PayloadAction<PackageAddForm>) {
  try {
    const response: ApiResponse = yield call(
      packageApi.addPackage,
      action.payload
    );
    const data: ApiResponse = response.data;
    if (data.success) {
      toast.success(data.message);
      yield put(packageActions.addPackageSuccess(data));
    }
  } catch (error: any) {
    const errorData = error?.response?.data;
    toast.error(errorData?.message || "Something went wrong");
    yield put(packageActions.addPackageFailed(errorData));
  }
}

function* updatePackage(action: PayloadAction<PackageUpdateForm>) {
  try {
    const response: ApiResponse = yield call(
      packageApi.updatePackage,
      action.payload
    );
    const data: ApiResponse = response.data;
    if (data.success) {
      toast.success(data.message);
      yield put(packageActions.updatePackageSuccess(data));
    }
  } catch (error: any) {
    const errorData = error?.response?.data;
    toast.error(errorData?.message || "Something went wrong");
    yield put(packageActions.updatePackageFailed(errorData));
  }
}

function* deletePackage(action: PayloadAction<RemovePayload>) {
  try {
    const response: ApiResponse = yield call(
      packageApi.deletePackage,
      action.payload
    );
    const data: ApiResponse = response.data;
    if (data.success) {
      toast.success(data.message);
      yield put(packageActions.deletePackageSuccess(data));
    }
  } catch (error: any) {
    const errorData = error?.response?.data;
    toast.error(errorData?.message || "Something went wrong");
    yield put(packageActions.deletePackageFailed(errorData));
  }
}

export default function* packageSaga() {
  yield takeLatest(packageActions.getModuleList.type, getModuleList);
  yield takeLatest(packageActions.getPackages.type, getPackage);
  yield takeLatest(packageActions.addPackage.type, addPackage);
  yield takeLatest(packageActions.updatePackage.type, updatePackage);
  yield takeLatest(packageActions.deletePackage.type, deletePackage);
}
